import api from './axiosInstance';

export interface CommentPermissionUser {
    id: number;
    fullName: string;
    email: string;
    isPremium: boolean;
    isAdmin: boolean;
    canComment: boolean;
}

export interface CommentPermissionPage {
    users: CommentPermissionUser[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
}

export async function fetchCommentPermissions(query: string, page: number): Promise<CommentPermissionPage> {
    const response = await api.get<CommentPermissionPage>('/admin/comment-permissions', {
        params: { query: query.trim() || undefined, page, size: 20 },
    });
    return response.data;
}

export async function setCommentPermission(
    userId: number,
    allowed: boolean
): Promise<CommentPermissionUser> {
    const response = await api.patch<CommentPermissionUser>(`/admin/comment-permissions/${userId}`, {
        allowed,
    });
    return response.data;
}

export async function demotePremiumUser(userId: number): Promise<CommentPermissionUser> {
    const response = await api.post<CommentPermissionUser>(`/admin/users/${userId}/demote`);
    return response.data;
}

export async function deleteAdminUser(userId: number, confirmationEmail: string): Promise<void> {
    await api.delete(`/admin/users/${userId}`, { data: { confirmationEmail } });
}
